import { render } from "./AppButtonVote.vue?vue&type=template&id=66adbce6&scoped=true"
import script from "./AppButtonVote.vue?vue&type=script&lang=js"
export * from "./AppButtonVote.vue?vue&type=script&lang=js"

import "./AppButtonVote.vue?vue&type=style&index=0&id=66adbce6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66adbce6"]])

export default __exports__